<div class="route-component">
    <div class="search-component">
        <h4>Access Denied</h4>

        <p>You are not authorized, please contact an administrator to verify your roles and assigned permissions.</p>
    </div>
</div>